module.exports = __webpack_public_path__ + "img/home-1.3438a5f7.png";